import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'

/**
 * Display the serial number for a sensor.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmTank = (classes, props = {}) => {
  const { tank = '-' } = props

  return (
    <Text
      color={'black'}
      variant={'14/regular'}
      className={classes.row}
    >
      {tank}
    </Text>
  )
}

export default CellHOC(ListItemCellXEcoApmTank)
